import { motion } from "motion/react";
import { Sprout, GraduationCap, Home, Briefcase } from "lucide-react";

export function ImpactPillars() {
  const pillars = [
    {
      icon: GraduationCap,
      title: "Education, Skills & Digital Literacy    (SDG 8, 10)",
      description:
        "Promoting education, vocational training, and digital literacy for rural and marginalised communities through institutions, scholarships, and skill development programs.",
      // impact: "3,200+ students trained",
    },
    {
      icon: Sprout,
      title: "Sustainable Livelihoods & Economic Inclusion (SDG 8, 10, 12)",
      description:
        "Creating lasting economic opportunities through sustainable tourism, agriculture, entrepreneurship, and market access for local communities and artisans.",
      // impact: "15,000+ people empowered",
    },
    {
      icon: Home,
      title: "Community Development & Social Welfare (SDG 10)",
      description:
        "Strengthening rural communities through healthcare, women and child welfare, senior citizen support, and essential social development programs.",
      // impact: "85+ villages transformed",
    },
    {
      icon: Briefcase,
      title: "Environment & Sustainable Development (SDG 12)",
      description:
        "Promoting environmental protection, tree plantation, and responsible living practices for long-term ecological balance and sustainability.",
      // impact: "2,400+ artisans supported",
    },
  ];

  return (
    <section className="py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-20"
        >
          <h2 className="text-4xl md:text-5xl mb-6">Why It Matters</h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Our work, supported by Immerse Travel Group, spans four key impact areas aligned with UN Sustainable Development Goals and UNWTO Goals 8, 10, and 12.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {pillars.map((pillar, index) => (
            <motion.div
              key={pillar.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group"
            >
              <div className="h-full p-8 rounded-2xl bg-white border border-border hover:border-primary/50 transition-all hover:shadow-lg">
                <div className="w-16 h-16 mb-6 rounded-full bg-primary/10 flex items-center justify-center group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <pillar.icon size={32} />
                </div>
                <h3 className="text-xl mb-3">{pillar.title}</h3>
                <p className="text-muted-foreground mb-4 leading-relaxed">
                  {pillar.description}
                </p>
                {/* <div className="text-sm font-semibold text-primary">
                  {pillar.impact}
                </div> */}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
